export default __webpack_public_path__ + "fonts/flUhRq6tzZclQEJVdgIuiaDsNc.woff2";